import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import membersService from "@/features/members/services/membersService";
import logger from "@/logger";

/**
 * Mutation hook for archiving a member (soft delete)
 * Sets the archivedAt timestamp on the user document
 */
export function useArchiveMember() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (uid: string) => membersService.archiveMember(uid),

        onError: (error: Error) => {
            logger.error("[useArchiveMember] Error archiving member:", error);
            toast.error(`Failed to archive member: ${error.message}`);
        },

        onSuccess: (_, uid) => {
            logger.debug("[useArchiveMember] Successfully archived member:", uid);

            queryClient.invalidateQueries({ queryKey: ["members"] });
            queryClient.invalidateQueries({ queryKey: ["member", uid] });

            toast.success("Member archived successfully");
        },
    });
}
